
<div *ngIf="!checkMan">
<!-- tệp đính kèm -->
<div *ngFor="let item of arrAttachments" class="row multiple-file">
  <ng-container *ngIf="isViewDetail; else notIsViewDetail">
    <div class="col-4 col-sm-4 col-lg-6 pl-3">
      <span class="fix-width" [matTooltip]="item.fileName">
        <em class="fa fa-file fa-fw text-primary"></em>
        {{item.fileName}}
      </span>
    </div>
    <div class="col-4 col-sm-4 col-lg-4 text-right">
      <span>
        {{item.fileSize | byte}}
      </span>
    </div>
    <div class="col-4 col-sm-4 col-lg-2 text-center" *ngIf="!isAttachFileForDocument">
      <span>
        <button class="btn-none" type="button">
          <em class="fa fa-download fa-fw text-primary" (click)="donwloadUrl(item.id, item.fileName)" matTooltip="{{'tooltips.download' | translate}}"></em>
        </button>
      </span>
    </div>
  </ng-container>
  <ng-template #notIsViewDetail>
    <ng-container *ngIf="item.name != undefined; else isFileName">
      <div class="col-4 col-sm-4 col-lg-8 pl-3">
        <span class="fix-width" [matTooltip]="item.name">
          <em class="fa fa-file fa-fw text-primary"></em>
          {{item.name}}
        </span>
      </div>
      <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          {{item.size | byte}}
        </span>
      </div>
      <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          <button type="button" class="btn-none">
            <em class="fa fa-trash fa-fw text-danger" (click)="deleteFile(item)" matTooltip="{{'tooltips.delete' | translate}}"></em>
          </button>
        </span>
      </div>
    </ng-container>

    <ng-template #isFileName>
      <div class="col-4 col-sm-4 col-lg-8 pl-3">
        <span class="fix-width" [matTooltip]="item.fileName">
          <em class="fa fa-file fa-fw text-primary"></em>
          {{item.fileName}}
        </span>
      </div>
      <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          {{item.fileSize | byte}}
        </span>
      </div>
      <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          <button class="btn-none" type="button" *ngIf="!isAttachFileForDocument">
            <em class="fa fa-download fa-fw text-primary" (click)="donwloadUrl(item.id, item.fileName)" matTooltip="{{'tooltips.download' | translate}}"></em>
          </button>
          <button type="button" class="btn-none">
            <em class="fa fa-trash fa-fw text-danger" (click)="deleteFile(item)" matTooltip="{{'tooltips.delete' | translate}}"></em>
          </button>
        </span>
      </div>
    </ng-template>
  </ng-template>
</div>
<div *ngIf="!isViewDetail" class="mt-3 text-center">
  <button mat-stroked-button color="primary" type="button" (click)="inputUpload.click()" class="mb-1">
    <mat-icon class="mr-0">cloud_upload</mat-icon> {{'form.select_attach' | translate}}
  </button>
  <input type="file" #inputUpload id="files" class="form-control-file vt-input-form d-none" name="files" (change)="getFiles($event)" multiple accept=".pdf,.jpg,.png,.bmp" />
  <small *ngIf="maxSizeInput" class="form-text text-danger">{{maxSizeMessage}}</small>
  <small *ngIf="errorFormatTypeFile" class="form-text text-danger">{{'messages.file_type' | translate}}</small>
</div>
</div>

<div *ngIf="checkMan" class="row">
  <!-- tệp đính kèm -->
  <div [hidden]="true">{{getFileNew()}}</div>
  <div class="col-8"><div *ngFor="let item of arrAttachments" class="row multiple-file ">
    <ng-container *ngIf="isViewDetail; else notIsViewDetail">
      <div class="col-4 col-sm-4 col-lg-6 pl-3">
      <span class="fix-width" [matTooltip]="item.fileName">
        <em class="fa fa-file fa-fw text-primary"></em>
        {{item.fileName}}
      </span>
      </div>
      <div class="col-4 col-sm-4 col-lg-4 text-right">
      <span>
        {{item.fileSize | byte}}
      </span>
      </div>
      <div class="col-4 col-sm-4 col-lg-2 text-center" *ngIf="!isAttachFileForDocument">
      <span>
        <button class="btn-none" type="button">
          <em class="fa fa-download fa-fw text-primary" (click)="donwloadUrl(item.id, item.fileName)" matTooltip="{{'tooltips.download' | translate}}"></em>
        </button>
      </span>
      </div>
    </ng-container>
    <ng-template #notIsViewDetail>
      <ng-container *ngIf="item.name != undefined; else isFileName">
        <div class="col-4 col-sm-4 col-lg-8 pl-3">
        <span class="fix-width" [matTooltip]="item.name">
          <em class="fa fa-file fa-fw text-primary"></em>
          {{item.name}}
        </span>
        </div>
        <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          {{item.size | byte}}
        </span>
        </div>
        <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          <button type="button" class="btn-none">
            <em class="fa fa-trash fa-fw text-danger" (click)="deleteFile(item)" matTooltip="{{'tooltips.delete' | translate}}"></em>
          </button>
        </span>
        </div>
      </ng-container>

      <ng-template #isFileName>
        <div class="col-4 col-sm-4 col-lg-8 pl-3">
        <span class="fix-width" [matTooltip]="item.fileName">
          <em class="fa fa-file fa-fw text-primary"></em>
          {{item.fileName}}
        </span>
        </div>
        <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          {{item.fileSize | byte}}
        </span>
        </div>
        <div class="col-4 col-sm-4 col-lg-2 text-right">
        <span>
          <button class="btn-none" type="button" *ngIf="!isAttachFileForDocument">
            <em class="fa fa-download fa-fw text-primary" (click)="donwloadUrl(item.id, item.fileName)" matTooltip="{{'tooltips.download' | translate}}"></em>
          </button>
          <button type="button" class="btn-none">
            <em class="fa fa-trash fa-fw text-danger" (click)="deleteFile(item)" matTooltip="{{'tooltips.delete' | translate}}"></em>
          </button>
        </span>
        </div>
      </ng-template>
    </ng-template>
  </div></div>
  <div class="col-8"><div *ngIf="!isViewDetail" class="mt-3 text-center">
    <button mat-stroked-button color="primary" type="button" (click)="inputUpload.click()" class="mb-1">
      <mat-icon class="mr-0">cloud_upload</mat-icon> {{'form.select_attach' | translate}}
    </button>
    <input type="file" #inputUpload id="files" class="form-control-file vt-input-form d-none" name="files" (change)="getFiles($event)" multiple accept=".pdf,.jpg,.png,.bmp" />
    <small *ngIf="maxSizeInput" class="form-text text-danger">{{maxSizeMessage}}</small>
    <small *ngIf="errorFormatTypeFile" class="form-text text-danger">{{'messages.file_type' | translate}}</small>
  </div></div>

</div>
